import { TokenConstants } from '../types';

const tokens: TokenConstants = {
  Popular: {
    Symbols: ['ART', 'USDC'],
  },
  InitialSwapTokens: {
    input: '0x8d9Bd7E9ec3cd799a659EE650DfF6C799309fA91',
    output: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
  },
  Addresses: {
    nativeAsset: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    wNativeAsset: '0x4a869ed6b3f74dC41537EF27e8eB3A8676AE4614',
    WETH: '0x4a869ed6b3f74dC41537EF27e8eB3A8676AE4614',
    BAL: '0xdd58D43a829067129B8C37f1924D31B1896ac0C6',
    bbaUSD: '',
    bbaUSDv2: '',
    rETH: '',
    stMATIC: '',
    stETH: '',
    wstETH: '',
  },
  PriceChainMap: {},
};

export default tokens;
